var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden-sm-and-down"},[_c('v-radio-group',{attrs:{"value":_vm.version},on:{"change":_vm.changeVersion}},_vm._l((_vm.versions),function(ver,i){return _c('v-radio',{key:i,attrs:{"label":ver,"value":ver}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }